import { RouteConfig } from '../types'

const routes: RouteConfig = {}

export default routes
